import { action, makeObservable, observable, reaction } from 'mobx';
import type { Location } from 'react-router';

interface IRouter {
    navigate(to: string, opts?: { replace?: boolean; state?: any }): void;
    state: { location: Location };
    subscribe(listener: (state: { location: Location }) => void): () => void;
}

export class RouterStore {
    @observable.ref location: Location = {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: window.history.state,
        key: 'default',
    };

    private _navigate: ((to: string, opts?: { replace?: boolean; state?: any }) => void) | null = null;

    constructor() {
        makeObservable(this);
    }

    init(router: IRouter) {
        this._updateLocation(router.state.location);
        this._navigate = (to, opts) => router.navigate(to, opts);
        router.subscribe(({ location }) => this._updateLocation(location));
    }

    @action
    private _updateLocation(location: Location) {
        this.location = location;
    }

    push(to: string, state?: any) {
        this._navigate?.(to, { state });
    }

    replace(to: string, state?: any) {
        this._navigate?.(to, { replace: true, state });
    }

    subscribe(listener: () => void): () => void {
        listener();
        return reaction(
            () => this.location.key,
            listener,
        );
    }
}
